<template>
  <div class="grid w-full grid-cols-1 gap-8">
    <div class="flex w-full flex-col gap-8 pb-10 md:gap-4">
      <QuestionHistogram
        v-for="question in questions"
        :key="question.question.id"
        :data="question"
        :topic-perspectives="topicPerspectives"
        :disable-animation="disableAnimation"
      />
      <div v-if="texts.length > 0">
        <TextFeedbackList
          :texts="texts"
          :expanded-question-id="expandedQuestionId"
          @question-clicked="questionClicked"
        />
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
  import type { PulseQuestionAnalysis, TextAnalysis } from '@/core/models/surveys-analytics'
  import type { Perspective } from '@/core/models/perspective'
  import QuestionHistogram from './question-histogram/QuestionHistogram.vue'
  import { ref } from 'vue'
  import TextFeedbackList from './text-feedback/TextFeedbackList.vue'

  interface Props {
    questions: ReadonlyArray<PulseQuestionAnalysis>
    texts?: ReadonlyArray<TextAnalysis>
    topicPerspectives: ReadonlyArray<Perspective>
    disableAnimation?: boolean
  }

  withDefaults(defineProps<Props>(), {
    texts: () => [],
  })

  const expandedQuestionId = ref<string | null>(null)

  const questionClicked = (questionId: string) => {
    expandedQuestionId.value = expandedQuestionId.value === questionId ? null : questionId
  }
</script>
